const dealer = {
  creationTime: '2016-12-28T11:14:00.0000000Z',
  id: 'fake-dealer',
  isActive: true,
  isEnabled: true,
  isOpened: true,
  lat: 0,
  long: 0,
  modificationTime: '2016-12-28T11:14:00.0000000Z',
  name: 'Fake Dealer',
  openingTimes: {
    monday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    tuesday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    wednesday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    thursday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    friday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    saturday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    sunday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
    holiday: {
      close: '21:00',
      open: '2:00',
      isOpened: true,
    },
  },
  phone: '+5511999999999',
  products: [
    {
      brand: 'SUPERGASBRAS',
      id: 'GASP13-SUPERGASBRAS',
      price: 50,
      type: 'GASP13',
    },
  ],
  rating: 5,
  supportPhone: '+5511992938503',
  utcOffsetMinutes: -180,
  willCloseAt: '2017-04-01T00:00:00.0000000Z',
  willOpenAt: '2017-04-01T00:00:00.0000000Z',
};

export default dealer;



// WEBPACK FOOTER //
// ../utils/mocks/dealer.js